/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getRadiologyStudies } from 'app/entities/radiology-study/radiology-study.reducer';
import { createEntity, getEntity, reset, updateEntity } from './radiology-report.reducer';

export const RadiologyReportUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const radiologyStudies = useAppSelector(state => state.radiologyStudy.entities);
  const radiologyReportEntity = useAppSelector(state => state.radiologyReport.entity);
  const loading = useAppSelector(state => state.radiologyReport.loading);
  const updating = useAppSelector(state => state.radiologyReport.updating);
  const updateSuccess = useAppSelector(state => state.radiologyReport.updateSuccess);

  const handleClose = () => {
    navigate(`/radiology-report${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getGlucoUsers({}));
    dispatch(getRadiologyStudies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.reportDate !== undefined && typeof values.reportDate !== 'number') {
      values.reportDate = Number(values.reportDate);
    }
    if (values.dateVoided !== undefined && typeof values.dateVoided !== 'number') {
      values.dateVoided = Number(values.dateVoided);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...radiologyReportEntity,
      ...values,
      reporter: doctors.find(it => it.id.toString() === values.reporter?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      study: radiologyStudies.find(it => it.id.toString() === values.study?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...radiologyReportEntity,
          reporter: radiologyReportEntity?.reporter?.id,
          patient: radiologyReportEntity?.patient?.id,
          study: radiologyReportEntity?.study?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.radiologyReport.home.createOrEditLabel" data-cy="RadiologyReportCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.radiologyReport.home.createOrEditLabel">Create or edit a RadiologyReport</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="radiology-report-id"
                  label={translate('tinyMedicRestApp.radiologyReport.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.reportStatus')}
                id="radiology-report-reportStatus"
                name="reportStatus"
                data-cy="reportStatus"
                type="text"
                validate={{
                  maxLength: { value: 12, message: translate('entity.validation.maxlength', { max: 12 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.reportDate')}
                id="radiology-report-reportDate"
                name="reportDate"
                data-cy="reportDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.reportBody')}
                id="radiology-report-reportBody"
                name="reportBody"
                data-cy="reportBody"
                type="text"
                validate={{
                  maxLength: { value: 300, message: translate('entity.validation.maxlength', { max: 300 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.voided')}
                id="radiology-report-voided"
                name="voided"
                data-cy="voided"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.dateVoided')}
                id="radiology-report-dateVoided"
                name="dateVoided"
                data-cy="dateVoided"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.microSec')}
                id="radiology-report-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.timestampentry')}
                id="radiology-report-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.lastupdated')}
                id="radiology-report-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.cursor')}
                id="radiology-report-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyReport.active')}
                id="radiology-report-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                id="radiology-report-reporter"
                name="reporter"
                data-cy="reporter"
                label={translate('tinyMedicRestApp.radiologyReport.reporter')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-report-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.radiologyReport.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-report-study"
                name="study"
                data-cy="study"
                label={translate('tinyMedicRestApp.radiologyReport.study')}
                type="select"
                required
              >
                <option value="" key="0" />
                {radiologyStudies
                  ? radiologyStudies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/radiology-report" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RadiologyReportUpdate;
